import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { DireccionComponent } from "app/features/componentes/direccion/direccion";

class ServiciosAdicionalesGuia extends React.PureComponent<{ value: models.ServiciosAdicionalesGuia }> {
    render() {
        const { value } = this.props;

        return (
            <kea.Panel title="Servicios adicionales">
                <kea.Json value={{
                    "Entrega a domicilio": value.EntregaDomicilio,
                    "Recolección a domicilio": value.RecoleccionDomicilio
                }} />
            </kea.Panel>
        );
    }
}


class OtrosGuia extends React.PureComponent<{ value: models.GuiaDTO }> {
    render() {
        const { value } = this.props;

        return (
            <kea.Panel title="Otros datos">
                <kea.Json value={{
                    "Flete por cobrar": value.FletePorCobrar,
                    "Distancia de flete": value.DistanciaFlete + " km",
                    "Nombre de la tarifa": value.NombreTarifa
                }} />
            </kea.Panel>
        );
    }
}

export class ResumenGuia extends React.PureComponent<{ value: models.GuiaDTO }> {
    render() {
        const { value } = this.props;
        return (
            <div>
                <h3>Resumen </h3>
                <kea.Json value={{
                    Origen: {
                        Cliente: value.NombreClienteOrigen,
                        Direccion: value.DireccionOrigenDTO.Descripcion
                    },
                    Destino: {
                        Cliente: value.NombreClienteDestino,
                        Direccion: value.DireccionDestinoDTO.Descripcion
                    },
                    Contenido: {
                        Paquetes: value.Paquetes.map(x => x.Cantidad).reduce((a, b) => a + b, 0),
                        Sobres: value.Sobres.map(x => x.Cantidad).reduce((a, b) => a + b, 0),
                        "Peso volumétrico: ": value.PesoVolumetrico,
                        "Peso": value.Peso + " kg",
                        //"Volumen": value.Volumen + " cm3",
                        "Volumen": value.Volumen/1000000 + " M3",
                    },
                    Pagada: value.Pagada,
                    Importes: value.Importes,
                    ImporteTotalSinDescuento: value.ImporteTotalSinDescuento,
                    Observaciones: value.Observaciones
                }} />
            </div>
        );
    }
}


type Entity = models.GuiaDTO;
export interface Props {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class DatosGuia extends React.PureComponent<Props> {
    getField = formfields(() => ({ value: this.props.value, readonly: true }));

    render() {
        const { value } = this.props;
        const getField = this.getField;


        const direccion: models.DireccionColonia = {
            ...value.DireccionDestino,
            IdColonia: value.IdColoniaDestino,
        };;

        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);

        return (
            <div>
                {kea.autogrid(6, [
                    <kea.Panel title="Generales" iconClass={fa("list-alt")} >
                        {kea.autogrid(6, [
                            <Text field="NombreClienteDestino" label="Cliente destino" />,
                            <kea.Text value={value.Pagada ? "Si" : "No"} label="Pagada" readonly />,
                            <Text field="NombrePersonaDocumento" label="Usuario documentó" readonly />,
                            <Text field="NombrePersonaEntrego" label="Persona entregó" readonly />,
                        ])}

                        <ServiciosAdicionalesGuia value={value.ServiciosAdicionales} />,
                        <OtrosGuia value={value} />,

                    </kea.Panel>,
                    <DireccionComponent value={direccion} readonly={true} label="Dirección de destino" />,

                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/datosguia.tsx